/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Battery properties for filtering. Timestamp represents time of telemetry event creation in date time format.
 */
export var BatteryPropertiesForTimeRangeFiltering;
(function (BatteryPropertiesForTimeRangeFiltering) {
    BatteryPropertiesForTimeRangeFiltering["TIMESTAMP"] = "timestamp";
})(BatteryPropertiesForTimeRangeFiltering || (BatteryPropertiesForTimeRangeFiltering = {}));
